import React, { useState } from 'react'
import styles from './navbar.module.scss'
import { useSelector } from 'react-redux'
import { AppState } from 'redux/reducers'
import { LG_DESKTOP_BREAKPOINT } from 'constants/global'
import useWindowSize from 'hooks/use-windowSize'
import WTNSpinner from 'components/generic/WTNSpinner'
import classNames from 'classnames'
import { MyAccount, MyProfile, MyWatchlists, SignIn, SignOut } from './links'
import { MY_SOCIAL_MATCHES_KEY } from 'types/global'
import cx from 'classnames'
import i18n from 'constants/strings'
import PopoverMenu from 'components/generic/PopoverMenu'
import { ReactComponent as AccountIcon } from 'images/icons/icn_user.svg'
import { RegisterBtn } from './buttons'

const Container = ({ children }) => (
  <ul className={styles.controlsContainer} data-testid='navbar-controls'>
    {children}
  </ul>
)

const AccountToggleWithMenu = () => {
  const [isOpen, setIsOpen] = useState(false)
  const hasPendingMatches = useSelector(
    (state: AppState) => !!state.socialMatches.totals[MY_SOCIAL_MATCHES_KEY]?.PENDING
  )

  return (
    <PopoverMenu
      menuId={'account-menu-popover'}
      triggerAriaLabel={i18n.t('strCommonUI.ariaLabel.accountMenu')}
      triggerContent={<AccountIcon aria-hidden />}
      withChevron
      classes={{ trigger: hasPendingMatches ? styles.iconNotificationBadge : '' }}
      controls={{ isOpen, setIsOpen }}
    >
      <nav>
        <ul className={styles.dropdownMenu}>
          <li className={hasPendingMatches ? styles.withNotificationBadge : ''}>
            <MyProfile />
          </li>
          <li>
            <MyAccount />
          </li>
          <li>
            <MyWatchlists />
          </li>
          <li>
            <SignOut />
          </li>
        </ul>
      </nav>
    </PopoverMenu>
  )
}

const ControlsLoggedIn = () => {
  return (
    <Container>
      <li className={styles.navItem}>
        <AccountToggleWithMenu />
      </li>
    </Container>
  )
}

const ControlsLoggedOut = () => (
  <Container>
    <li className={cx(styles.navItem, styles.signIn)}>
      <SignIn />
    </li>
    <li className={styles.navItem}>
      <RegisterBtn />
    </li>
  </Container>
)

const NavbarControls = () => {
  const windowWidth = useWindowSize().width
  const isLoggedIn = useSelector((state: AppState) => state.user.isLoggedIn)
  const appReady = useSelector((state: AppState) => state.user.appReady)
  const appError = useSelector((state: AppState) => state.user.appError)

  if (windowWidth && windowWidth < LG_DESKTOP_BREAKPOINT) return null

  if (!appReady && !appError)
    return (
      <div className={classNames(styles.loaderContainer, styles.loaderContainerControls)}>
        <WTNSpinner width={30} />
      </div>
    )

  if (isLoggedIn) return <ControlsLoggedIn />

  return <ControlsLoggedOut />
}

export default NavbarControls
